import { useDate } from '@circlefin/hooks'
import { useInvoiceDetailQuery } from '@shared/graphql'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

export interface PaidInvoiceHeaderProps {
  /**
   * Invoice ID.
   */
  invoiceId: string
}

export const Paid: React.FC<PaidInvoiceHeaderProps> = ({ invoiceId }) => {
  const { t } = useTranslation('settings')
  const { date } = useDate()
  const { data } = useInvoiceDetailQuery({ variables: { id: invoiceId } })

  return (
    <div className="ml-auto w-3/5 text-right">
      <span
        className="ml-2 text-2xl leading-7 text-green-200 font-circular-bold"
        data-testid="invoice-paid-title"
      >
        {t('settings:billing.invoices.status.paid')}
      </span>
      <div
        className={classNames(
          'py-2 mt-2 font-circular-regular leading-4 text-black-200',
          'text-xs',
        )}
        data-testid="invoice-paid-sub-text"
      >
        {t('billing.invoices.details.summary.invoicePaid', {
          invoiceDate:
            data?.invoiceDetail.invoiceDate &&
            date(data.invoiceDetail.invoiceDate, 'date'),
        })}
      </div>
    </div>
  )
}
